import { BaseDynamicFormElement } from './dynamic-form-base.class';
import { BaseDynamicFormElementInterface } from './base-dynamic-form-element.interface';

export class CheckboxElement extends BaseDynamicFormElement<boolean> {
  constructor(config: Partial<BaseDynamicFormElementInterface<boolean>>) {
    super({
      ...config,
      controlType: 'checkbox',
    });
  }
}
